<template>
  <div class="navigation">
    <a href="/" class="logo">ClientGrid</a>
    <ul class="primary">
      <router-link tag="li" to="/features"><a>Features</a></router-link>
      <li
        @click="
          $intercom.showNewMessage(`Hi there. I'd like to request a demo.`)
        "
      >
        <a>Demo</a>
      </li>
    </ul>
    <ul :class="{ dark: isDark }" class="secondary">
      <li @click="$router.push('/login')"><a>Login</a></li>
    </ul>
    <ul class="mobile-bars">
      <i
        class="fa fa-bars"
        aria-hidden="true"
        @click="showMobileMenuModal = true"
      />
    </ul>
    <transition
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >
      <div v-if="showMobileMenuModal" class="modal mobile-menu">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-body row">
              <div class="col-xs-12 features ml-3">
                <router-link
                  v-for="(feature, index) in features['legal']"
                  :key="index"
                  :to="`/features/${feature.alias}`"
                  class="feature"
                >
                  <span
                    :style="{
                      background: feature.lighter,
                      color: feature.darker
                    }"
                    class="icon"
                  >
                    <i :class="feature.icon" class="fa" aria-hidden="true" />
                  </span>
                  <span class="title">{{ feature.title }}</span>
                </router-link>
              </div>
              <button
                type="button"
                class="close"
                data-dismiss="modal"
                aria-label="Close"
                @click="showMobileMenuModal = false"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="actions">
              <button
                class="request-demo"
                @click="
                  $intercom.showNewMessage(
                    `Hi there. I'd like to request a demo.`
                  )
                "
              >
                Request Demo
              </button>
              <button
                class="learn-more float-right"
                @click="$router.push('/login')"
              >
                Login
              </button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import features from "./features";
// import $ from "jquery";

export default {
  computed: {
    features() {
      return features;
    }
  },

  data() {
    return {
      showMobileMenuModal: false
    };
  },

  props: {
    isDark: {
      type: Boolean
    }
  },

  watch: {
    // showMobileMenuModal(value) {
    //   if (value) {
    //     this.$store.commit("setModalOpen", true);
    //   } else {
    //     this.$store.commit("setModalOpen", false);
    //   }
    // }
  }
};
</script>

<style lang="scss" scoped>
.navigation {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  height: 74px;

  .logo {
    position: absolute;
    left: 0;
    text-decoration: none;
    font-size: 25px;
    font-weight: 600;

    &:after {
      content: "beta";
      position: absolute;
      width: 30px;
      height: 15px;
      background: #33334f;
      top: 0;
      right: -32px;
      color: white;
      font-size: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 7px;
      font-weight: 600;
    }
  }

  li {
    list-style: none;
    display: inline-block;

    a {
      color: #767ead;
      font-size: 13px;
      font-weight: 600;
      letter-spacing: 1px;
      text-transform: uppercase;
      padding: 30px 20px;

      &:hover {
        text-decoration: none;
        color: black;
      }
    }
  }

  .primary,
  .secondary {
    text-align: center;
    margin: 0;
    padding: 0;
  }

  .secondary {
    position: absolute;
    right: 0;

    &.dark {
      li a {
        color: #767ead;
      }
    }

    li a {
      color: white;
    }
  }

  .mobile-bars {
    display: none;
  }

  .mobile-menu {
    .modal-content {
      position: relative;
    }

    button.close {
      position: absolute;
      top: 10px;
      right: 30px;
      z-index: 1;
    }

    .features {
      .feature {
        text-decoration: none;
        margin: 0 0 20px;
        display: flex;
        align-items: center;

        .icon {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          font-size: 12px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .title {
          color: black;
          margin-left: 10px;
        }
      }
    }

    .actions {
      margin: 0 20px 20px;
    }
  }

  @media (max-width: 992px) {
    .primary,
    .secondary {
      display: none;
    }

    .mobile-bars {
      display: block;
      position: absolute;
      right: 0;
    }
  }
}
</style>
